import React from "react";
import ReactDOM from "react-dom";
import popupStyles from '../views/patient-enrollment/PatientEnrollmentPopUp.module.css';
import styles from './GroupSelectPopup.module.css';
import OrganizationTreeSelect, { useSelectedTeams, SelectionProvider } from './OrganizationTreeSelect';
import { XOut } from "./icons/Icons";


const GroupSelectPopup = ({initialSelections, organizationData, handleSave, onClose}) => {

     const handleExtract = (info) => {
        const groups = info.groups.filter((group)=>group.organizationId !== 0 && group.teamId !== 0);
        handleSave(groups);
        onClose();
    };

      
    const ExtractInfoButton = () => {
        const extract = useSelectedTeams();
      
        const handleExtract = (info) => {
            const groups = info.groups.filter((group)=>group.organizationId !== 0 && group.teamId !== 0);
            handleSave(groups);
            onClose();
        };

        return (
            <div className={styles.ButtonContainer}>
                <button className={styles.CancelButton} onClick={onClose}>Cancel</button>
                <button className={styles.SaveButton} onClick={handleExtract}>Save</button>
            </div>
          );
    };

    return ReactDOM.createPortal(
        <div key="group_select_popup" className={popupStyles.PopupOverlay}>
            <div className={styles.PopupContainer}>
                <div onClick={()=>onClose()} className={styles.CloseOut}>
                   <XOut />
                </div>
                    <div>
                        <SelectionProvider initialSelections={initialSelections}>
                            <OrganizationTreeSelect organizations={organizationData} onClose={onClose} handleExtract={handleExtract}/>
                        </SelectionProvider>
                    </div>
            </div>
        </div>,
        document.body
    );
}

export default GroupSelectPopup;